import { defineMessages } from 'react-intl-next';
export const contextPanelMessages = defineMessages({
	panelLabel: {
		id: 'fabric.editor.contextPanel.panelLabel',
		defaultMessage: 'Context panel',
		description: 'Label for the context panel',
	},
});
